export function useCardPaymentTiming() {
  const { $paymentMethods } = useNuxtApp();
  const { roundNumber, gatewayType } = useHelpers();
  const { track } = useEventsDispatcher();

  const startTime = performance.now();
  const authorizationStartTime = ref<number | null>(null);
  const authorizationEndTime = ref<number | null>(null);
  const acceptStartTime = ref<number | null>(null);
  const acceptEndTime = ref<number | null>(null);

  function startAuthorization(): void {
    authorizationStartTime.value = performance.now();
  }

  function finishAuthorization(): void {
    if (authorizationStartTime.value === null) return;

    authorizationEndTime.value = (performance.now() - authorizationStartTime.value) / 1000;
  }

  function startAccept(): void {
    acceptStartTime.value = performance.now();
  }

  function finishAccept(): void {
    if (acceptStartTime.value === null || acceptStartTime.value <= 0) return;

    acceptEndTime.value = (performance.now() - acceptStartTime.value) / 1000;
  }

  function trackPaymentDuration(result: 'success' | 'error'): void {
    track('Payment duration', {
      type: $paymentMethods.card,
      gateway: gatewayType.value,
      authorization_duration: roundNumber(authorizationEndTime.value),
      backend_payment_duration: roundNumber(acceptEndTime.value),
      total_duration: roundNumber((performance.now() - startTime) / 1000),
      result,
    });
  }

  return {
    startAuthorization,
    finishAuthorization,
    startAccept,
    finishAccept,
    trackPaymentDuration,
  };
}
